var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "vs-tabs",
        [
          _c(
            "vs-tab",
            { staticClass: "pt-10", attrs: { label: "Utilisateurs" } },
            [
              _c("UserTab", {
                attrs: {
                  api: this.api,
                  perpage: this.perpage,
                  userType: "Utilisateur",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "vs-tab",
            { staticClass: "pt-10", attrs: { label: "Evaluateurs" } },
            [
              _c("UserTab", {
                attrs: {
                  api: this.api,
                  perpage: this.perpage,
                  userType: "Evaluateur",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }